import { render, staticRenderFns } from "./AIEstheSoundTherapyPage.vue?vue&type=template&id=5b498183&scoped=true&"
import script from "./AIEstheSoundTherapyPage.vue?vue&type=script&lang=ts&"
export * from "./AIEstheSoundTherapyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b498183",
  null
  
)

export default component.exports